import { MarkEmailRead, MarkEmailUnread } from "@mui/icons-material"
import { Box, Card, CardContent, CardHeader, Chip, Tooltip, Typography } from "@mui/material"
import { FC, useState } from "react"
import { markUserNotificationAsRead, UserNotification } from "src/apis/user"
import { formatDateToBR } from "src/utils/date"
import { Id } from "src/utils/types"

type NotificationCardProps = {
  notification: UserNotification,
  setError: (error: string) => void;
  onReadSuccess?: (notification: UserNotification) => void;
}

const NotificationCard: FC<NotificationCardProps> = ({notification, setError, onReadSuccess = () => {}}): JSX.Element => {
  const [read, setRead] = useState<boolean>(notification.lida);

  const readNotification = async (id: Id): Promise<void> => {
    try {
      await markUserNotificationAsRead(id)

      setRead(true);
      setError('');
      onReadSuccess(notification)
    } catch (e: any) {
      setError("Falha ao marcar notificação como lida")
    }
  }

  return (
    <Card variant="outlined">
      <CardHeader
        title={notification.nome_remetente}
        subheader={formatDateToBR(notification.criado_em)}
        titleTypographyProps={{
          variant: 'h6'
        }}
        action={
          <>
            {read ? (
              <Box>
                <Tooltip title="Notificação lida">
                  <Chip
                    label={
                      <strong>
                        Lida
                      </strong>
                    }
                    color="primary"
                    variant="outlined"
                    icon={<MarkEmailUnread />}
                  />
                </Tooltip>
              </Box>
            ) : (
              <Box>
                <Tooltip title="Marcar notificação como lida">
                  <Chip
                    label={
                      <strong>
                        Não lida
                      </strong>
                    }
                    color="primary"
                    icon={<MarkEmailRead />}
                    onClick={() => {
                      readNotification(notification.user_notification_id);
                    }}
                  />
                </Tooltip>
              </Box>
            )}
          </>
        }
      />
      <CardContent>
        <Typography>
          {notification.mensagem}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default NotificationCard;
